import React from 'react';

export default function Analytics() {
  return (
    <div style={{ padding: '2rem', background: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0', minHeight: '600px' }}>
      <h1>Analytics</h1>
      <p style={{ color: '#64748b' }}>Deep dive into your rental trends and customer insights.</p>
    </div>
  );
}
